import { Filters } from "./filters";
import { Summary } from "./summary";
import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const ShopFeeReportConfig: ReportConfigBase = {
  type: EReportTypes.ShopFee,
  endpoint: "charge",
  reportKey: "charges",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The shop fee report provides a detailed breakdown of fees associated with your shops, allowing you to analyze costs and profitability effectively.",
    // TODO: Need a help article once this is ready
    url: "https://help.commonsku.com/knowledge/",
  },
};

export default ShopFeeReportConfig;
